import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { OneTrustIcon } from './OneTrustIcon';
import { FooterInfoModal } from './FooterInfoModal';
import { PreferenceCenterModal } from './PreferenceCenterModal';
import { supabase } from '../lib/supabase';

interface FooterProps {
  onCookieSettings: () => void;
}

export function Footer({ onCookieSettings }: FooterProps) {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isPreferenceCenterOpen, setIsPreferenceCenterOpen] = useState(false);
  const [preferenceCenterUrl, setPreferenceCenterUrl] = useState('');

  useEffect(() => {
    async function getPreferenceUrl() {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('token')
          .eq('id', user.id)
          .single();
        
        if (profile?.token) {
          setPreferenceCenterUrl(`https://fllr-privacy.my.onetrust.com/ui/#/preferences/multipage/token/e2ad2b7f-6313-4a31-ab73-46d6d0295871/${profile.token}`);
        } else {
          setPreferenceCenterUrl('https://fllr-privacy.my.onetrust.com/ui/#/preferences/multipage/login/e2ad2b7f-6313-4a31-ab73-46d6d0295871');
        }
      } else {
        setPreferenceCenterUrl('https://fllr-privacy.my.onetrust.com/ui/#/preferences/multipage/login/e2ad2b7f-6313-4a31-ab73-46d6d0295871');
      }
    }

    getPreferenceUrl();
  }, []);

  return (
    <>
      <footer className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-t border-gray-200 dark:border-gray-700 mt-auto transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-center items-center space-x-8">
            <button 
              onClick={onCookieSettings}
              className="text-gray-600 dark:text-gray-400 hover:text-[#5e9bb8] dark:hover:text-[#5e9bb8] transition-colors duration-200"
            >
              Cookie Settings
            </button>
            <Link 
              to="/privacy"
              className="text-gray-600 dark:text-gray-400 hover:text-[#5e9bb8] dark:hover:text-[#5e9bb8] transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/privacy-center"
              className="text-gray-600 dark:text-gray-400 hover:text-[#5e9bb8] dark:hover:text-[#5e9bb8] transition-colors duration-200"
            >
              Privacy Center
            </Link>
            <button
              onClick={() => setIsPreferenceCenterOpen(true)}
              className="text-gray-600 dark:text-gray-400 hover:text-[#5e9bb8] dark:hover:text-[#5e9bb8] transition-colors duration-200"
            >
              Your Privacy Choices
            </button>
            <button
              onClick={() => setIsInfoModalOpen(true)}
              className="relative group"
              aria-label="Learn more about OneTrust integrations"
            >
              <div className="absolute -inset-2 bg-green-500 rounded-full opacity-20 info-beacon"></div>
              <OneTrustIcon size="lg" />
            </button>
          </div>
        </div>
      </footer>

      <FooterInfoModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
      />

      <PreferenceCenterModal
        isOpen={isPreferenceCenterOpen}
        onClose={() => setIsPreferenceCenterOpen(false)}
        url={preferenceCenterUrl}
      />
    </>
  );
}